import { render, staticRenderFns } from "./ProfileSearch.vue?vue&type=template&id=a71bd7d6"
import script from "./ProfileSearch.vue?vue&type=script&lang=js"
export * from "./ProfileSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports